import axios from 'axios';

export const apiAuth = axios.create({
    //baseURL: "http://localhost:4000", // Servidor desenvolvimento
    baseURL: "https://icvcalcapi.cnpma.embrapa.br"
});

export default apiAuth